(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyDealerLookup', ['$rootScope', function () {

            // Magic number: This delay is enough for iOS to pick up the new radio
            // button positioning for the expandable radios we use for dealer lookup
            //
            var SCROLL_INTO_VIEW_DELAY_MS = 50;

            DealerLookupController.$inject = ['$scope', '$attrs', '$rootScope', '$http', '$q', 'Postcodes', 'Dealers', 'ScrollIntoView', '$timeout'];
            function DealerLookupController($scope, $attrs, $rootScope, $http, $q, Postcodes, Dealers, ScrollIntoView, $timeout) {
                var dlc = this;

                function updateState(state) {
                    $scope.searchingDealers = state.searchingDealers;
                    $scope.dealersLoaded = state.dealersLoaded;
                    $scope.noDealers = state.noDealers;

                    $scope.isLabelVisible = state.dealersLoaded && !state.noDealers;
                    $scope.isOptionsVisible = !state.searchingDealers && state.dealersLoaded && !state.noDealers;
                    $scope.isLoadingSpinnerVisible = state.searchingDealers && !state.dealersLoaded;
                    $scope.isMessageVisible = !$scope.isLoadingSpinnerVisible;
                    $scope.isDealerLookupVisible = state.searchingDealers || $scope.isLabelVisible;

                    $scope.serviceFilterList = dlc.serviceFilterList ? JSON.parse(dlc.serviceFilterList) : [];
                }

                $scope.init = function () {
                    $scope.tags = [];
                    $scope.dealers = null;

                    updateState({
                        searchingDealers: false,
                        dealersLoaded: false,
                        noDealers: false
                    });

                    $scope.ds = {
                        tags: [],
                        type: 'Sales',
                        results: [],
                        loading: false,
                        dealerAdded: '',
                        currentDealer: '',
                        analyticsTag: ''
                    };

                    if ($scope.ds.tags.length > 0) {
                        $scope.searchNow();
                    }
                };

                $scope.dealerSearch = function ($tag) {
                    $scope.ds.tags = [];
                    $scope.ds.tags[0] = $tag;
                    $scope.searchNow();
                    $scope.ds.dealerAdded = $tag.text;
                    $scope.ds.analyticsTag = $tag.tagInfo.suburb + ', ' + $tag.tagInfo.state + ' ' + $tag.tagInfo.postCode;
                };

                $scope.disableSubmitOnEnterKey = function (event) {
                    if (event.keyCode == 13) {
                        event.preventDefault();
                    }
                }

                $scope.searchNow = function () {
                    var tagInfo = $scope.ds.tags[0].tagInfo;
                    var maxResults = $attrs.maxResults;
                    var serviceType = $scope.serviceType ? $scope.serviceType : 'new';

                    updateState({
                        searchingDealers: true,
                        dealersLoaded: false,
                        noDealers: false
                    });

                    Dealers(tagInfo.postCode, tagInfo.suburb, maxResults, serviceType).then(function (data) {
                        var dealers = [];

                        // add a unique number to each ID to ensure that ID's of each element are unique
                        // Otherwise, if both dealers have the same code, you won't be able to select the second one
                        // as the IDs of the options will be the same, so both labels will 'point' to the first option
                        var uniqueNo = 1;

                        angular.forEach(data, function (value, key) {
                            dealers.push({
                                name: value.name,
                                address: constructAddress(value.city.toLowerCase(), value.state, value.postCode),
                                code: value.dealerCode,
                                branch: value.branchCode,
                                street: value.address + ',',
                                location: value.city + ' ' + value.state + ', ' + value.postCode,
                                addressUrl: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(value.name + ', ' + value.address + ', ' + value.city + ' ' + value.state + ', ' + value.postCode),
                                website: value.webSite,
                                serviceTypes: filterServiceTypes(value.serviceTypes),
                                uniqueNo: uniqueNo,
                                dealerObj: value,
                                suburb: value.city,
                            });

                            uniqueNo++;
                        });

                        updateState({
                            searchingDealers: false,
                            dealersLoaded: true,
                            noDealers: dealers.length === 0
                        });

                        $scope.dealers = dealers;
                    });
                };

                $scope.removedTag = function ($tag) {
                    updateState({
                        searchingDealers: false,
                        dealersLoaded: false,
                        noDealers: false
                    });

                    $scope.ds.dealerAdded = '';
                    $scope.ds.analyticsTag = '';
                    $scope.ds.currentDealer = '';
                    $scope.clearDealerInformation();
                };

                $scope.clearDealerInformation = function () {
                    $scope.fields.dealerSelected = false;
                    $scope.fields.dealer.dealerCode = '';
                    $scope.fields.dealer.sapDealerCode = '';
                    $scope.fields.dealer.branchCode = '';
                    $scope.fields.dealer.name = '';
                    $scope.fields.dealer.address = '';
                    $scope.fields.dealer.suburb = '';
                    $scope.fields.dealer.postCode = '';
                    $scope.fields.dealer.state = '';
                    $scope.fields.dealer.telephone = '';
                    $scope.fields.dealer.email = '';
                    $scope.fields.dealer.website = '';
                };

                $scope.shouldShowDealerDetails = function (dealerBranch) {
                    return $scope.showDealerInfo && dealerBranch === $scope.ds.currentDealer;
                };

                $scope.loadTags = function (query) {
                    $scope.ds.loading = true;

                    var deferred = $q.defer();
                    var maxResults = $attrs.maxResults;
                    var x = Postcodes(query, maxResults);

                    x.then(function (tags) {
                        $scope.ds.loading = false;

                        deferred.resolve(tags);
                    }).catch(function (err) {
                        $scope.ds.loading = false;
                        deferred.reject();
                    });

                    return deferred.promise;
                };

                $scope.scrollIntoViewBySelector = function (radioSelector) {
                    // Wait for Angular digest to finish up, then go for it
                    $timeout(function () {
                        ScrollIntoView(angular.element(radioSelector));
                    }, SCROLL_INTO_VIEW_DELAY_MS);
                };

                function filterServiceTypes(types) {
                    var dealerServiceTypes = types.map(function (type) {
                        return type.toLowerCase();
                    });

                    var serviceTypesToShow = $scope.serviceFilterList.reduce(function (includedServices, serviceType) {
                        if (dealerServiceTypes.indexOf(serviceType.Service_Type_Name.toLowerCase()) !== -1) {
                            includedServices.push(serviceType.Label);
                        }

                        return includedServices;
                    }, []);

                    return serviceTypesToShow;
                }

                function constructAddress(city, state, postcode) {
                    if ($scope.showDealerInfo) {
                        return city;
                    }

                    return city + ' ' + state + ', ' + postcode;
                }
            }

            return {
                scope: true,
                restrict: 'A',
                controller: DealerLookupController,
                controllerAs: 'dlc',
                bindToController: {
                    serviceFilterList: '@tyDealerLookupServiceTypeFilter'
                },
                link: function (scope, element, attrs) {
                    var ATTR_MODAL = '[data-ty-modal]';
                    var ATTR_MODAL_CLOSE = '[data-ty-modal-close]'; 

                    scope.$on('clear-dealer-search-input', function () {
                        element.find('tags-input input')[0].value = '';
                    });

                    // re-initalise the form if a parent modal is closed
                    window.addEventListener('load', () => {
                        angular.forEach(element.closest(ATTR_MODAL)
                            .find(ATTR_MODAL_CLOSE), function(ele) {
                                angular.element(ele)
                                    .on('click', function() {
                                        scope.init();
                                        scope.$apply();
                                    });
                            }
                        )
                    });
                }
            };
        }]);
})(window.angular);
